<template>
    <div>
        <div class="mb10">
            <span class="font14px text-bold pr20 pointer" @click="toListPage">
                <i class="el-icon-back"></i>Return</span>|
            <span class="font14px text-bold pl20 pr20 pointer">{{this.type=='add'?'Create':'Edit'}} Task</span>
            <el-button :loading="submitLoading" :disabled="taskNameLoading" type="primary" size="mini" @click="handleSubmit">Save</el-button>
        </div>
        <el-form :inline="true" :model="formItem" :rules="rules" ref="form" size="mini" v-loading="dataLoading">
            <el-form-item label="Task Name：" prop="task_name" class="label-required">
                <el-input v-model.trim="formItem.task_name" placeholder="Please enter the task name" style="width:230px;" clearable />
            </el-form-item>
            <el-form-item label="Automatic Generation Time：" prop="generate_time" class="label-required">
                <span class="text-normal mr6">Every </span>
                <el-select multiple v-model="formItem.generate_frequency" @change="changeWeek" placeholder="Please select" class="mr6" style="width: 420px">
                    <el-option label="Mon." value="1"></el-option>
                    <el-option label="Tue." value="2"></el-option>
                    <el-option label="Wed." value="3"></el-option>
                    <el-option label="Thu." value="4"></el-option>
                    <el-option label="Fri." value="5"></el-option>
                    <el-option label="Sat." value="6"></el-option>
                    <el-option label="Sun." value="7"></el-option>
                </el-select>

                <el-time-picker
                    :clearable="false"
                    style="width:150px;"
                    v-model="formItem.generate_time"
                    :picker-options="pickerOptions"
                    value-format="HH:mm"
                    format="HH:mm"
                    placeholder="Select a Time">
                </el-time-picker>
            </el-form-item>
            <el-form-item label="Receive Configuration：" class="label-required">
                <el-button type="primary" @click="showEmailModal" class="mr20" plain>Configuration</el-button>
                <span v-if="isConfigMail" class="font12px">Email<span class="text-color-success">(Configured)</span></span>
                <span v-else class="font12px">Email<span class="text-color-error">(Not configured)</span></span>
            </el-form-item>
        </el-form>
        <div class="file-data-list" v-loading="dataLoading">
            <div class="tool-bar clearfix">
                <div class="fl">
                    <el-button type="primary" @click="showFileModal">Add task file</el-button>
                </div>
                <div class="fr">
                    <el-form :inline="true" :model="formSearch" ref="formSearch" size="mini">
                        <el-form-item label="">
                            <el-input v-model.trim="formSearch.file_name" placeholder="File Name" style="width:200px;" clearable />
                        </el-form-item>
                        <el-form-item label="">
                            <el-input v-model.trim="formSearch.account" placeholder="Account Name, ID" style="width:200px;" clearable />
                        </el-form-item>
                        <el-form-item label="">
                            <el-input v-model.trim="formSearch.app" placeholder="Product Name, ID, Package Name" style="width:200px;" clearable />
                        </el-form-item>
                        <el-form-item label="">
                            <el-select v-model="formSearch.template" placeholder="Template Name" @visible-change="templateSelectVisibleChange" :loading="templateLoading" style="width:120px;" filterable clearable>
                                <el-option
                                    v-for="item in templateList"
                                    :key="item.template_id"
                                    :label="item.template_name"
                                    :value="item.template_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="">
                            <el-button type="primary" @click="searchFileList" class="mr10" plain>Search</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <el-table
                ref="dataTable"
                :data="filterDataList"
                tooltip-effect="dark"
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                stripe
                style="width: 100%;">
                <el-table-column
                    type="index"
                    label="Serial Number"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="daily_file_name"
                    show-overflow-tooltip
                    label="File Name"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="plat_name"
                    label="Media"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="account"
                    label="Account & Product"
                    min-width="100">
                    <template slot-scope="scope">
                        <el-popover width="460" trigger="hover">
                            <span slot="reference" class="text-color-primary pointer">
                                <span class="mr10" v-if="scope.row.company.length>0">Account（{{scope.row.company.length}}）</span>
                                <span class="mr10" v-if="scope.row.app.length>0">Product（{{scope.row.app.length}}）</span>
                                <span class="mr10" v-if="scope.row.customer.length>0">Client（{{scope.row.customer.length}}）</span>
                            </span>
                            <div style="max-height: 360px;overflow-y: auto;">
                                <div class="company-list" v-if="scope.row.company.length>0">
                                    <h3>Account</h3>
                                    <p v-for="item in scope.row.company||[]" :key="item.account_id" class="pl20 ellipsis" :title="item.account_name+'-'+(scope.row.plat_name=='vivo'?item.user_name:item.account_id)">{{item.account_name}}（{{scope.row.plat_name=='vivo'?item.user_name:item.account_id}}）</p>
                                </div>
                                <div class="app-list" v-if="scope.row.app.length>0">
                                    <h3>Product</h3>
                                    <p v-for="item in scope.row.app||[]" :key="item.subitem_id" class="pl20 ellipsis" :title="item.subproject_name+'-'+item.subproject_id+(scope.row.plat_name=='vivo'?('（'+item.subproject_content+'）'):'')">{{item.subproject_name}}（{{item.subproject_id}}）<span v-if="scope.row.plat_name=='vivo'">（{{item.subproject_content}}）</span></p>
                                </div>
                                <div class="customer-list" v-if="scope.row.customer.length>0">
                                    <h3>Client</h3>
                                    <p v-for="item in scope.row.customer||[]" :key="item.company_name" class="pl20 ellipsis" :title="item.company_name">{{item.company_name}}</p>
                                </div>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="template_name"
                    label="Template"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="template_id"
                    label="Statistics Period"
                    min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.statistical_period=='1'">Last 7 days</span>
                        <span v-else-if="scope.row.statistical_period=='2'">Last 30 days</span>
                        <span v-else-if="scope.row.statistical_period=='3'">All campaign dates</span>
                        <span v-else-if="scope.row.statistical_period=='4'">Last {{scope.row.time_slot}} days</span>
                        <span v-else-if="scope.row.statistical_period=='5'">Start Date {{scope.row.time_slot_date}}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    prop="action"
                    label="Actions"
                    align="center"
                    min-width="100">
                    <template slot-scope="scope">
                        <span class="text-color-primary pointer pl6 pr6" @click="editFile(scope.row)">Edit</span>
                        <span class="text-color-error pointer pl6 pr6" @click="removeFile(scope.row)">Delete</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page-bar tac mt20">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryData.pn"
                :page-sizes="[30,50,100]"
                :page-size="queryData.rn"
                :pager-count="5"
                layout="total, sizes, prev, pager, next, jumper"
                :total="filterDataList.length">
            </el-pagination>
        </div>

        <MailConfigModal ref="mailConfigModal" :data="mailItem" @save="saveMailConfig"/>
        <TaskFileModal ref="taskFileModal" :data="actionFileData" :task-type="type" :type="actionFileType" :page-func-names="pageFuncNames" :allowed-plat-list="allowedPlatList" @submit="submitFileData"/>
    </div>
</template>

<script>
    import API from '@/api/efficiencyToolEn/task.js';
    import TaskFileModal from './modal/taskFileModal';
    import MailConfigModal from './modal/mailConfigModal';
    import utils from '@/libs/utils.js';

    export default {
        name: "CreatePage",
        components:{
            TaskFileModal,
            MailConfigModal,
        },
        props:{
            allowedPlatList:Array,
            data:Object,
            type:String,
            pageFuncNames:Array,
        },
        data(){
            let _this = this;
            const task_name = (rule, value, callback) => {
                if(!value){
                    callback(new Error('Task name cannot be empty'));
                }else if(value.length >40){
                    return callback(new Error('Task name cannot exceed 40 characters'));
                }else{
                    // _this.taskNameLoading=true;
                    // API.checkTaskName({
                    //     task_name:value,
                    //     task_id:_this.data.task_id||'',
                    // }).then(()=>{
                    //     callback();
                    //     _this.taskNameLoading=false;
                    // },err=>{
                    //     callback(new Error(err.info||'任务名称不能重复'));
                    //     _this.taskNameLoading=false;
                    // })
                    callback();
                }
            };
            const generate_time = (rule, value, callback) => {
                if(!_this.formItem.generate_time){
                    callback(new Error('Automatic generation time cannot be empty'));
                }else if(_this.formItem.generate_frequency.length<=0){
                    callback(new Error('Please select generation period'));
                }else{
                    callback();
                }
            };
            return {
                taskNameLoading:false,
                submitLoading:false,
                dataLoading:false,
                formItem:{
                    task_name:'',
                    generate_time:'09:00',
                    generate_frequency:[],
                },
                mailItem:{
                    direction_email:'',
                    email:'',
                    body:'',
                    zip_send:'',
                    is_send:'',
                    send_type:'',
                    title_date:'1',
                },
                formSearch:{
                    file_name:'',
                    account:'',
                    app:'',
                    template:'',
                },
                dataList:[],
                isConfigMail:false,
                pickerOptions:{
                    format:'HH:mm',
                    // selectableRange: '10:00:00 - 23:59:59',

                },
                rules:{
                    task_name:[
                        { validator:task_name, trigger: 'blur' }
                    ],
                    generate_time:[
                        // { required: true, message: '请选择自动生成时间', trigger: 'change' },
                        { validator:generate_time, trigger: ['blur','change'] }
                    ],
                },
                queryData:{
                    pn:1,
                    rn:10,
                },
                actionFileData:{},
                actionFileType:'',
                templateList:[],
                templateLoading:false,
            }
        },
        computed:{
            filterDataList(){
                if(!this.formSearch.file_name&&!this.formSearch.account&&!this.formSearch.app&&!this.formSearch.template){
                    return this.dataList;
                }
                return this.dataList.filter(item=>{
                    if(!this.formSearch.file_name) return true;
                    return item.daily_file_name.includes(this.formSearch.file_name);
                }).filter(item=>{
                    if(!this.formSearch.account) return true;
                    let companyList = item.company||[];
                    return companyList.some(inner=>inner.account_id.includes(this.formSearch.account)||inner.account_name.includes(this.formSearch.account));
                }).filter(item=>{
                    if(!this.formSearch.app) return true;
                    let appList = item.app||[];
                    return appList.some(inner=>inner.subitem_id.includes(this.formSearch.app) || inner.subproject_id.includes(this.formSearch.app)||inner.subproject_name.includes(this.formSearch.app)||inner.subproject_content.includes(this.formSearch.app));
                }).filter(item=>{
                    if(!this.formSearch.template) return true;
                    return this.formSearch.template?item.template_id== this.formSearch.template:true;
                });
            },
        },
        mounted(){
            this.getTemplateList();
            console.log('create mounted',this.type);
            if(this.type=='add'){
                this.formItem.generate_frequency = ['1','2','3','4','5','6','7'];
            }
        },
        methods:{
            toListPage(){
                this.$emit('back');
            },
            setData(){
                console.log('setData',this.data);

                this.getTaskInfo();
            },
            getTemplateList(){
                /* 获取模板下拉列表*/
                this.templateLoading = true;
                API.getSearchTemplateList().then(res=>{
                    this.templateList = res.data||[];
                    this.templateLoading = false;
                },err=>{
                    console.log('getSearchTemplateList',err);
                    this.templateList = [];
                    this.templateLoading = false;
                });
            },
            getTaskInfo(){
                let taskId = this.data.task_id;
                this.dataLoading = true;
                API.getTaskInfo({
                    task_id:taskId,
                }).then(res=>{
                    console.log('getTaskInfo',res);
                    this.dataLoading = false;
                    let resData = res.data||{};

                    this.formItem.task_name = resData.task_name;
                    this.formItem.generate_time = resData.generate_time_format;
                    this.formItem.generate_frequency = (resData.generate_frequency||"").split('');

                    this.mailItem.direction_email = resData.direction_email.replace(/\;/g,",");
                    this.mailItem.email = resData.email.replace(/\;/g,",");
                    this.mailItem.body = resData.body;
                    this.mailItem.zip_send = resData.zip_send;
                    this.mailItem.is_send = resData.is_send;
                    this.mailItem.send_type = resData.send_type;
                    this.mailItem.title_date = resData.title_date;
                    this.mailItem.title = resData.title;
                    this.isConfigMail = true;


                    this.dataList = (resData.daily_list||[]).map(item=>{
                        return {
                            ...item,
                            task_detail_id:item.task_detail_id,
                            plat_id:item.plat_id,
                            plat_name:item.plat_name,
                            template_id:item.template_id,
                            template_name:item.template_name,
                            selectAPPType:item.select_type||'1',
                            daily_file_name:item.daily_file_name,
                            file_date:item.file_date,
                            time_slot:item.statistical_period=='4'?item.time_slot:'',
                            statistical_period:item.statistical_period,
                            time_slot_date:item.statistical_period=='5'?item.time_slot:'',
                            company:item.account_info||[],
                            app:item.app_info||[],
                            customer:item.customer_info||[],
                        };
                    });

                },err=>{
                    console.log('getTaskInfo err',err);
                    this.dataLoading = false;
                })
            },
            changeWeek(val){
                console.log('changeWeek',val);
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        if(!this.isConfigMail) return this.$message.error('Email reception is not configured');
                        if(this.dataList.length<=0) return this.$message.error('Please add the task file first');

                        let taskId = this.type=='edit'?this.data.task_id||'':'';

                        let reqData = {
                            id:taskId,
                            task_name:this.formItem.task_name,
                            generate_time:this.formItem.generate_time,
                            generate_frequency:this.formItem.generate_frequency.join(''),

                            /*邮件信息*/
                            title_date:this.mailItem.title_date,
                            title:this.mailItem.title,
                            direction_email:this.mailItem.direction_email.replace(/\;/g,","),
                            email:this.mailItem.email.replace(/\;/g,","),
                            zip_send:this.mailItem.zip_send,
                            is_send:this.mailItem.is_send,
                            send_type:this.mailItem.send_type,
                            body:this.mailItem.body,
                        };

                        let detailData = this.dataList.map(item=>{
                            /* 处理[统计周期]的值 */
                            let timeSlotVal = '';
                            if(item.statistical_period=='4'){
                                timeSlotVal = item.time_slot;
                            }else if(item.statistical_period=='5'){
                                timeSlotVal = item.time_slot_date;
                            }


                            //判断是否是前端自己添加的detailId
                            let isRandom = (item.task_detail_id||'').includes('random-');
                            return {
                                plat_id:item.plat_id,
                                plat_name:item.plat_name,
                                template_id:item.template_id,
                                template_name:item.template_name,
                                selectAPPType:item.selectAPPType,
                                daily_file_name:item.daily_file_name,
                                file_date:item.file_date,
                                statistical_period:item.statistical_period,
                                time_slot:timeSlotVal,
                                time_zone:item.plat_id=='9'?item.time_zone:'',
                                app:item.app,
                                company:item.company,
                                customer:item.customer,
                                detail_id:isRandom?'':item.task_detail_id,
                            }
                        });

                        reqData.detail = JSON.stringify(detailData);

                        this.submitLoading = true;
                        API.saveDailyTask(reqData).then(res=>{
                            console.log('saveDailyTask',res);

                            this.submitLoading = false;
                            this.$message.success(res.info||'');

                            this.toListPage();
                            this.$emit('update');
                        },err=>{
                            console.log('saveDailyTask err',err);
                            this.submitLoading = false;

                            let errData = err.data||[];
                            if(err.code==0&&errData.length>0){
                                this.$notify.error({
                                    title: err.info||'Request Error',
                                    dangerouslyUseHTMLString: true,
                                    message: "<div>"+errData.map(item=>`<p class="font12px">${item.errorMsg}；</p>`).join('')+"</div>",
                                    duration: 0
                                });
                            }else{
                                this.$message.error(err.info||'Request Error');
                            }
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            showEmailModal(){
                this.$refs.mailConfigModal.showModal();
            },
            showFileModal(){
                this.actionFileData = {};
                this.actionFileType = 'add';
                this.$refs.taskFileModal.showModal();
            },
            templateSelectVisibleChange(val){
                if(val){
                    this.getTemplateList();
                }
            },
            searchFileList(){
                console.log('searchFileList');
            },
            saveMailConfig(data){
                this.isConfigMail = true;
                this.mailItem.direction_email = data.direction_email.replace(/\;/g,",");
                this.mailItem.email = data.email.replace(/\;/g,",");
                this.mailItem.title = data.title;
                this.mailItem.body = data.body;
                this.mailItem.zip_send = data.zip_send;
                this.mailItem.is_send = data.is_send;
                this.mailItem.send_type = data.send_type;
                this.mailItem.title_date = data.title_date;
            },
            submitFileData(type,data){
                console.log('submitFileData',type,data);
                if(type == 'add'){
                    data.task_detail_id= 'random-'+utils.randomString(16);
                    this.dataList.push(data);
                }else if(type=='edit'){
                    let actionItem = this.dataList.find(item=>item.task_detail_id==data.task_detail_id);
                    if(actionItem){
                        actionItem.task_detail_id = data.task_detail_id;
                        actionItem.plat_id = data.plat_id;
                        actionItem.template_id = data.template_id;
                        actionItem.template_name = data.template_name;
                        actionItem.selectAPPType = data.selectAPPType;
                        actionItem.time_zone = data.time_zone;
                        actionItem.daily_file_name = data.daily_file_name;
                        actionItem.statistical_period = data.statistical_period;
                        actionItem.time_slot = data.time_slot;
                        actionItem.time_slot_date = data.time_slot_date;
                        actionItem.app = [...data.app];
                        actionItem.company = [...data.company];
                        actionItem.customer = [...data.customer];
                        actionItem.file_date = data.file_date;
                    }else{
                        console.log('数据有误');
                    }
                }
            },
            editFile(row){
                console.log('editFile',row);
                this.actionFileType = 'edit';
                this.actionFileData = utils.deepClone(row);
                this.$refs.taskFileModal.showModal();
            },
            removeFile(row){
                this.$alert('Are you sure you want to delete file ：<span class="text-bold">'+row.daily_file_name+'</span> ?', {
                    type:'error',
                    confirmButtonText:'Confirm',
                    confirmButtonClass:'danger-button',
                    showCancelButton:true,
                    dangerouslyUseHTMLString:true,
                }).then(()=>{
                    let index = this.dataList.findIndex(item=>item.task_detail_id==row.task_detail_id);
                    this.dataList.splice(index,1);
                }).catch(()=>{
                    console.log('取消删除');
                });
            },
            handleSizeChange(val){
                console.log('handleSizeChange',val);
            },
            handleCurrentChange(val){
                console.log('handleCurrentChange',val);
            },
        },
    }
</script>

<style lang="scss" scoped>

    .file-data-list {
        padding: 10px;
        border: solid 1px #dcdee2;
        min-height: 300px;
    }
</style>
